import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { getSearchQuery } from "components/SearchInput/helpers";
import useTableSort from "components/Table/useTableSort";
import { BlueprintIntegrationAttachment, SearchQueryOrderDirection } from "types/generated";

import {
  INTEGRATION_USED_BY_COLUMN_ID,
  INTEGRATION_USED_BY_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortIntegrationUsedBy } from "./helpers";

export const useSortingIntegrationUsedBy = (blueprints: BlueprintIntegrationAttachment[] = []) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: INTEGRATION_USED_BY_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INTEGRATION_USED_BY_COLUMN_ID.NAME,
    initialSortDirection: SearchQueryOrderDirection.Asc,
  });

  const filteredBlueprints = useMemo(() => {
    let filtered = [...blueprints];

    if (searchInput) {
      filtered = filtered.filter((blueprint) =>
        blueprint.blueprintName?.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    if (sortDescriptor.column) {
      filtered = sortIntegrationUsedBy(filtered, sortDescriptor);
    }

    return filtered;
  }, [blueprints, searchInput, sortDescriptor]);

  return {
    filteredBlueprints,
  };
};
